/**
 * Catálogo centralizado de MODALIDADES del estudiante.
 * Mantener sincronizado con MODALIDAD_CHOICES en escolar/models.py (EscEstudiante).
 *
 * Catálogo vigente (2026-05): PRESENCIAL | EN_LINEA.
 * Se almacena en BD como string uppercase con guion bajo, consistente con
 * otras tablas del sistema (EscGrupo.modalidad).
 */

export const MODALIDAD_OPTIONS = [
  { value: 'PRESENCIAL', label: 'Presencial' },
  { value: 'EN_LINEA',   label: 'En Línea' },
];

const MODALIDAD_ALIASES = {
  'EN-LÍNEA': 'EN_LINEA',
  'EN-LINEA': 'EN_LINEA',
  'ENLINEA':  'EN_LINEA',
  'PRESENCIAL': 'PRESENCIAL',
};

export const MODALIDAD_LABELS = MODALIDAD_OPTIONS.reduce(
  (acc, opt) => { acc[opt.value] = opt.label; return acc; },
  {}
);

export function normalizeModalidad(value) {
  if (!value) return '';
  const up = String(value).trim().toUpperCase();
  return MODALIDAD_ALIASES[up] || up;
}

export function getModalidadLabel(value, fallback = 'No especificada') {
  if (!value) return fallback;
  const normalized = normalizeModalidad(value);
  return MODALIDAD_LABELS[normalized] || String(value);
}
